import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, ShieldCheck, RefreshCw, PackageCheck } from 'lucide-react';
import logo from '../assets/logo-bk-mobility.png';
import { t } from '../locales/nl';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="page-container pt-8">
        <div className="text-center mb-8">
          <img src={logo} alt="BK Mobility logo" className="h-12 mb-6 mx-auto" />
          <h1 className="text-3xl font-bold mb-2">{t.homepageTitle}</h1>
          <p className="text-neutral-600">{t.homepageSubtitle}</p>
        </div>
        
        <div className="grid grid-cols-1 gap-2 max-w-sm mx-auto">
          <Link 
            to="/ophaal" 
            className="card flex items-center hover:shadow-md transition-shadow px-3 py-5"
          >
            <div className="bg-blue-100 p-3 rounded-full mr-4">
              <Truck size={24} className="text-blue-600" />
            </div>
            <div>
              <h2 className="text-lg font-medium">{t.ophaalFormTitle}</h2>
              <p className="text-sm text-neutral-600">{t.ophaalFormDescription}</p>
            </div>
          </Link>

          <Link 
            to="/aflever" 
            className="card flex items-center hover:shadow-md transition-shadow px-3 py-5"
          >
            <div className="bg-green-100 p-3 rounded-full mr-4">
              <ShieldCheck size={24} className="text-green-600" />
            </div>
            <div>
              <h2 className="text-lg font-medium">{t.afleverFormTitle}</h2>
              <p className="text-sm text-neutral-600">{t.afleverFormDescription}</p>
            </div>
          </Link>
          
          <Link 
            to="/omruil" 
            className="card flex items-center hover:shadow-md transition-shadow px-3 py-5"
          >
            <div className="bg-amber-100 p-3 rounded-full mr-4">
              <RefreshCw size={24} className="text-amber-600" />
            </div>
            <div>
              <h2 className="text-lg font-medium">{t.omruilFormTitle}</h2>
              <p className="text-sm text-neutral-600">{t.omruilFormDescription}</p>
            </div>
          </Link>
          
          <Link 
            to="/inname" 
            className="card flex items-center hover:shadow-md transition-shadow px-3 py-5"
          >
            <div className="bg-purple-100 p-3 rounded-full mr-4">
              <PackageCheck size={24} className="text-purple-600" />
            </div>
            <div>
              <h2 className="text-lg font-medium">{t.innameFormTitle}</h2>
              <p className="text-sm text-neutral-600">{t.innameFormDescription}</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomePage;